import { IconButton, IconButtonProps, ModalProps, Drawer } from '@mui/material';
interface DashboardOpenIconButtonParentProps {
  isSidebarOpen?: boolean;
}

export const DashboardOenIconButtonParent = <C extends React.ElementType>(
  props: IconButtonProps<C, { component?: C }> & DashboardOpenIconButtonParentProps,
) => <IconButton {...props}>{props.children}</IconButton>;

interface CustomDrawerProps {
  headerHeight?: number;
}

export const CustomDrawer = <C extends React.ElementType>(
  props: ModalProps<C, { component?: C }> & CustomDrawerProps,
) => <Drawer {...props}>{props.children}</Drawer>;
